<template>
  <div>
    <div class="rightAside">
      <!-- 生态宜居 -->
      <div class="f_right">
        <div class="f_right_shengtaiyiju">
          <div
            class="f_pingluo_top"
            style="border-bottom: 1px dashed rgba(74, 252, 209, 0.6)"
          >
            <div>
              <span class="f_img_border"><img :src="f_img_line" alt="" /></span>
              <span class="f_font_border"
                ><img :src="f_font_seven" alt=""
              /></span>
            </div>
          </div>
          <div class="f_shengtaiyiju_cont">
            <!-- 视频 -->
            <div class="f_xuanchaunpian">
              <div class="chidren_logo first_font">平罗县宣传片</div>
              <div class="f_xuanchuan_cont">
                <img
                  :src="xuanchuan_img"
                  alt=""
                  @click="dialogVisible_xuanchuan = true"
                />
              </div>
              <!-- 视频弹框 -->
              <div class="video">
                <el-dialog
                  :visible.sync="dialogVisible_xuanchuan"
                  width="50%"
                  :modal="false"
                  :close-on-click-modal="false"
                  :show-close="false"
                  :destroy-on-close="true"
                >
                  <span slot="title">
                    <img :src="f_font_two" alt="" class="dialog-title1" />
                  </span>
                  <img
                    :src="detail_icon_one"
                    alt=""
                    class="close-icon"
                    @click="close"
                  />
                  <div>
                    <SwiperOne />
                  </div>
                </el-dialog>
              </div>
            </div>
            <!-- 气象 -->
            <div class="f_qixiang">
              <div class="chidren_logo first_font">智慧气象</div>
              <div class="f_qixiang_cont" v-if="homeList.tem != undefined">
                <p class="tet_center" style="color: #fff; font-size: 16px">
                  {{ homeList.dates }}
                  <span style="margin-left: 4px">{{ homeList.citys }}县</span>
                </p>
                <div class="weather" @click="dialogVisible_weather = true">
                  <div class="weather_left">
                    <p>
                      <img
                        v-if="homeList.wea_img == 'xue'"
                        :src="weather_img.img_xue"
                        alt="#"
                        class="weather_img_size"
                      />
                      <img
                        v-if="homeList.wea_img == 'lei'"
                        :src="weather_img.img_lei"
                        alt="#"
                        class="weather_img_size"
                      />
                      <img
                        v-if="homeList.wea_img == 'shachen'"
                        :src="weather_img.img_shachen"
                        alt="#"
                        class="weather_img_size"
                      />
                      <img
                        v-if="homeList.wea_img == 'wu'"
                        :src="weather_img.img_wu"
                        alt="#"
                        class="weather_img_size"
                      />
                      <img
                        v-if="homeList.wea_img == 'bingbao'"
                        :src="weather_img.img_bingbao"
                        alt="#"
                        class="weather_img_size"
                      />
                      <img
                        v-if="homeList.wea_img == 'yun'"
                        :src="weather_img.img_yun"
                        alt="#"
                        class="weather_img_size"
                      />
                      <img
                        v-if="homeList.wea_img == 'yu'"
                        :src="weather_img.img_yu"
                        alt="#"
                        class="weather_img_size"
                      />
                      <img
                        v-if="homeList.wea_img == 'yin'"
                        :src="weather_img.img_yin"
                        alt="#"
                        class="weather_img_size"
                      />
                      <img
                        v-if="homeList.wea_img == 'qing'"
                        :src="weather_img.img_qing"
                        alt="#"
                        class="weather_img_size"
                      />
                    </p>
                    <p style="text-align: center; font-size: 12px">
                      {{ homeList.wea }}
                    </p>
                  </div>
                  <div class="weather_right">
                    <p class="text_center" style="font-size: 24px">
                      {{ homeList.tem }}℃
                    </p>
                    <p class="text_center" style="margin-top: 10px">
                      {{ homeList.tem2 }}℃-{{ homeList.tem1 }}℃
                    </p>
                  </div>
                </div>
                <!-- 天气弹框 -->
                <div>
                  <el-dialog
                    :visible.sync="dialogVisible_weather"
                    width="50%"
                    :modal="false"
                    :close-on-click-modal="false"
                    :show-close="false"
                    :destroy-on-close="true"
                  >
                    <span slot="title">
                      <img :src="f_font_weather" alt="" class="dialog-title" />
                    </span>
                    <img
                      :src="detail_icon_one"
                      alt=""
                      class="close-icon"
                      @click="dialogVisible_weather = false"
                    />
                    <div>
                      <Weather />
                    </div>
                  </el-dialog>
                </div>
                <!-- Swiper -->
                <div class="swiper-container1">
                  <div class="swiper-wrapper">
                    <div
                      class="swiper-slide"
                      v-for="(item, index) in hoursList"
                      :key="index"
                    >
                      <div>
                        <p>{{ item.hours }}</p>
                        <div>
                          <img
                            v-if="item.wea_img == 'xue'"
                            :src="weather_img.img_xue"
                            alt="#"
                            class="hours_img"
                          />
                          <img
                            v-if="item.wea_img == 'lei'"
                            :src="weather_img.img_lei"
                            alt="#"
                            class="hours_img"
                          />
                          <img
                            v-if="item.wea_img == 'shachen'"
                            :src="weather_img.img_shachen"
                            alt="#"
                            class="hours_img"
                          />
                          <img
                            v-if="item.wea_img == 'wu'"
                            :src="weather_img.img_wu"
                            alt="#"
                            class="hours_img"
                          />
                          <img
                            v-if="item.wea_img == 'bingbao'"
                            :src="weather_img.img_bingbao"
                            alt="#"
                            class="hours_img"
                          />
                          <img
                            v-if="item.wea_img == 'yun'"
                            :src="weather_img.img_yun"
                            alt="#"
                            class="hours_img"
                          />
                          <img
                            v-if="item.wea_img == 'yu'"
                            :src="weather_img.img_yu"
                            alt="#"
                            class="hours_img"
                          />
                          <img
                            v-if="item.wea_img == 'yin'"
                            :src="weather_img.img_yin"
                            alt="#"
                            class="hours_img"
                          />
                          <img
                            v-if="item.wea_img == 'qing'"
                            :src="weather_img.img_qing"
                            alt="#"
                            class="hours_img"
                          />
                        </div>
                        <p>{{ item.tem }}℃</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-else>
                <p style="font-size: 20px; line-height: 100px">暂无数据</p>
              </div>
            </div>
          </div>
          <div>
            <AsideVideo />
          </div>
        </div>
      </div>
      <!-- 村居通 -->
      <div class="f_right_shuzinongye">
        <div
          class="f_pingluo_top"
          style="border-bottom: 1px dashed rgba(74, 252, 209, 0.6)"
        >
          <div>
            <span class="f_img_border"><img :src="f_img_line" alt="" /></span>
            <span class="f_font_border1"
              ><img :src="f_font_eidht" alt=""
            /></span>
          </div>
          <div @click="dialogVisibleNumNongye = true">
            <img :src="f_font_one" alt="" style="cursor: pointer" />
          </div>
        </div>
        <!-- 村居通 弹框 -->
        <div class="cjt">
          <el-dialog
            :visible.sync="dialogVisibleNumNongye"
            width="50%"
            :modal="false"
            :close-on-click-modal="false"
            :show-close="false"
            :destroy-on-close="true"
            center
          >
            <span slot="title">
              <img :src="detail_title" alt="" class="dialog-title1" />
            </span>
            <img
              :src="detail_icon_one"
              alt=""
              class="close-icon"
              @click="dialogVisibleNumNongye = false"
            />
            <div>
              <SelectCjt />
            </div>
          </el-dialog>
        </div>
        <div class="f_shuzinongye_cont">
          <AsideTwo />
        </div>
      </div>
      <!-- 应用示范 -->
      <div class="f_right_yingyongshifan">
        <div
          class="f_pingluo_top"
          style="border-bottom: 1px dashed rgba(74, 252, 209, 0.6)"
        >
          <div>
            <span class="f_img_border"><img :src="f_img_line" alt="" /></span>
            <span class="f_font_border"><img :src="f_font_nice" alt="" /></span>
          </div>
        </div>
        <div class="f_yingyongshifan_cont">
          <vue-seamless-scroll
            :data="system_one"
            :class-option="classOption"
            class="seamless-warp"
          >
            <ul>
              <li v-for="(item, index) in system_one" :key="index">
                <div class="flex_news">
                  <span>{{ item.type }}：</span
                  ><span style="margin: 0 4px"
                    ><a :href="item.systemUrl" target="_blank">{{
                      item.systemName
                    }}</a></span
                  >
                </div>
              </li>
            </ul>
          </vue-seamless-scroll>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SwiperOne from "../swiper/swiper.vue";
import Weather from "../weather/weather.vue";
import AsideTwo from "./rightAside2.vue";
import AsideVideo from "./rightAsideVideo";
// 村居通 二级页面进入
import SelectCjt from "./detail_cjt/select_cjt.vue";
export default {
  name: "rightAside",
  components: {
    Weather,
    SwiperOne,
    AsideTwo,
    AsideVideo,
    SelectCjt,
  },
  data() {
    return {
      // 二级页面开关
      dialogVisible_weather: false,
      dialogVisible_xuanchuan: false,
      dialogVisibleNumNongye: false,
      detail_title: require("@/assets/images/cjt.jpg"),
      detail_lang_title: require("@/assets/images/蒙版组 31.png"),
      detail_quality_title: require("@/assets/images/蒙版组 29.png"),
      detail_farm_title: require("@/assets/images/ncp.png"),
      detail_icon_one: require("@/assets/images/路径 28736_2@2x.png"),
      f_img_line: require("@/assets/images/line.png"),
      // 宣传片
      f_font_two: require("@/assets/images/蒙版组 25.png"),
      // 智慧气象
      f_font_weather: require("@/assets/images/蒙版组 24.png"),
      f_font_one: require("@/assets/images/路径 28803.png"),
      f_font_seven: require("@/assets/images/蒙版组 4.png"),
      f_font_eidht: require("@/assets/images/村居通.png"),
      f_font_nice: require("@/assets/images/蒙版组 17.png"),
      nongye_img_zhizao: require("@/assets/images/路径 28788.png"),
      nongye_img_nainiu: require("@/assets/images/组 15075.png"),
      nongye_img_shucai: require("@/assets/images/组 15077.png"),
      nongye_img_rouniu: require("@/assets/images/路径 28797.png"),
      nongye_img_tanyang: require("@/assets/images/路径 28798@2x.png"),
      xuanchuan_img: require("@/assets/images/xuanchuangpian.png"),
      // 天气预报数据
      homeList: {
        dates: "",
        citys: "",
        wea: "",
        tem: "",
        tem1: "",
        tem2: "",
        wea_img: "",
      },
      // 小时天气
      hoursList: [],
      hoursList_img: "",

      weather_img: {
        img_xue: require("@/assets/images/xue.png"),
        img_lei: require("@/assets/images/lei.png"),
        img_shachen: require("@/assets/images/shachen.png"),
        img_wu: require("@/assets/images/wu.png"),
        img_bingbao: require("@/assets/images/bingbao.png"),
        img_yun: require("@/assets/images/yun.png"),
        img_yu: require("@/assets/images/yu.png"),
        img_yin: require("@/assets/images/yin.png"),
        img_qing: require("@/assets/images/qing.png"),
      },
      system_one: [
        {
          type: "数字治理",
          systemName: "石嘴山盐碱地改良",
          systemUrl: "http://szsyjdgl.com/tiaozhuan.html",
        },
        {
          type: "数字服务",
          systemName: "政法委综合治理系统",
          systemUrl: "http://59.221.21.103:8080",
        },
        {
          type: "数字产业",
          systemName: "农产品质量溯源平台",
          systemUrl: "http://zlzs.nbjcj.com",
        },
        {
          type: "数字产业",
          systemName: "一牧云系统",
          systemUrl: "http://www.yimucloud.com/index",
        },
        {
          type: "数字产业",
          systemName: "智能饲喂中心系统",
          systemUrl: "http://tmr.aotoso.com/",
        },
        {
          type: "数字产业",
          systemName: "粮油果蔬食品安全监督平台",
          systemUrl: "https://plx.verytong.com/plx/index/index.html",
        },
      ],
      // system_two: [],
      // system_three: [],
      // system_four: [],
    };
  },
  computed: {
    classOption() {
      return {
        step: 0.3, //数值越大速度滚动越快
        limitMoveNum: 1, //开始无缝滚动的数据量  //this.fourDatata.length
        hoverStop: true, //是否开启鼠标悬停stop
        direction: 1, // 0向下 1向上 2向左 3向右
        openWatch: true, //开启数据实时监控刷新dom
        singleHeight: 0, //单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, //单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 2500, //单步运动停止的时间(默认值1000ms)
      };
    },
  },
  methods: {
    // 天气预报
    weather() {
      var weatherList = plOtherDataInterface.getTodayWeather();
      this.homeList.citys = weatherList.city;
      this.homeList.dates = weatherList.date;
      this.homeList.wea = weatherList.wea;
      this.homeList.tem = weatherList.tem;
      this.homeList.tem1 = weatherList.tem1;
      this.homeList.tem2 = weatherList.tem2;
      this.hoursList = weatherList.hours;
      this.homeList.wea_img = weatherList.wea_img;
    },
    close() {
      this.dialogVisible_xuanchuan = false;
    },
    app_demo() {
      var _demo = plOtherDataInterface.getDemonstrationList();
      // this.system_one = _demo.digitIndustryList;
      // this.system_two = _demo.digitManageList;
      // this.system_three = _demo.digitServiceList;
      // this.system_four = _demo.villagePointList;
    },
  },
  mounted() {
    this.app_demo();
    this.weather();
    var mySwiper = new Swiper(".swiper-container1", {
      slidesPerView: 4,
      paginationClickable: true,
      spaceBetween: 20,
      observer: true,
    });
  },
};
</script>

<style scoped lang="less">
.rightAside {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-content: space-between;
}
.f_img_border {
  width: 1.125rem;
  height: 1.125rem;
  margin-right: 0.3125rem;
}
.f_img_border img,
.f_font_border img,
.nongye_img img {
  width: inherit;
  height: inherit;
}
.dialog-title {
  width: 156px;
  height: 40px;
}
.dialog-title1 {
  width: 206px;
  height: 40px;
}
.f_font_border {
  width: 5.625rem;
  height: 1.225rem;
  display: inline-block;
}
.f_font_border1 {
  width: 4.625rem;
  height: 1.005rem;
  display: inline-block;
}
.font_PI {
  color: rgb(62, 248, 156);
}
.nongye_img {
  width: 2rem;
  height: 2rem;
  margin: auto;
}
.font_PI_one {
  font-size: 24px;
}
.font_PI_two {
  font-size: 8px;
}
.font_PI_three {
  font-size: 0.75rem;
}
.first_font {
  font-size: 16px;
  text-align: left;
  padding-left: 0.625rem;
}
.f_xuanchuan_cont {
  width: 100%;
  height: auto;
}
.f_xuanchuan_cont img {
  width: 100%;
  height: 100%;
  cursor: pointer;
}
.f_right_shengtaiyiju,
.f_right_shuzinongye,
.f_right_yingyongshifan {
  padding: 9.6px 11.2px;
  margin: 4px 0;
  background: url("../../assets/images/border.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
.f_right_shengtaiyiju {
  color: #fff;
}
.f_pingluo_top {
  display: flex;
  justify-content: space-between;
  padding-bottom: 0.475rem;
  border-bottom: 1px solid rgba(74, 252, 209, 0.6);
  position: relative;
}
.chidren_logo {
  background-image: linear-gradient(
    to right,
    rgb(121, 226, 154),
    rgba(62, 248, 156, 0)
  );
  border-left: 4px solid rgb(62, 248, 156);
}
.f_shengtaiyiju_cont {
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
}
.f_xuanchaunpian,
.f_qixiang {
  width: 50%;
  margin-top: 0.5rem;
}
.f_xuanchuan_cont,
.f_qixiang_cont {
  margin: 10px 0 0 0;
}
.f_qixiang_cont {
  padding: 0px 0.625rem;
  box-sizing: border-box;
}
.f_xuanchuan_cont {
  padding: 0px 5px;
  box-sizing: border-box;
}
.f_shuzinongye_cont,
.f_yingyongshifan_cont {
  margin: 0.625rem 0 0 0;
}
.f_yingyongshifan_cont .seamless-warp {
  width: 100%;
  height: 8.5vh;
  overflow: hidden;
}
.Seed_industry,
.dairy_industry,
.vegetable_industry,
.beef_cattle_industry,
.Tibet_lamb_industry,
.transaction_data {
  display: flex;
  justify-content: space-around;
}
.div {
  width: 33%;
}
.f_shuzinongye_cont {
  font-size: 16px;
  line-height: 32px;
  text-align: center;
}
.f_yingyongshifan_cont {
  line-height: 1.5625rem;
  color: #fff;
}
.agriculture_logo {
  height: 2rem;
  background-size: cover;
  background-repeat: no-repeat;
  background: url("../../assets/images/agriculture.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  cursor: pointer;
}
.f_yingyongshifan_cont a {
  color: rgb(62, 248, 156);
}
.weather {
  display: flex;
  margin: 5px 0 0 0;
  justify-content: space-around;
  padding: 7px 10px;
  cursor: pointer;
}
.weather_right {
  margin-left: 0.625rem;
}
.weather_img_size {
  width: 60px;
}
.weather_table {
  width: 100%;
  font-size: 10px;
}
.hours_img {
  width: 30px;
  height: 25px;
  margin: 5px 0;
}
/deep/ .el-dialog {
  background: #15606e;
  border: 1px solid #2bf9fc;
  margin-top: 15vh !important;
}
.video /deep/ .el-dialog {
  background: #15606e;
  border: 1px solid #2bf9fc;
  margin-top: 17vh !important;
}
.cjt /deep/ .el-dialog {
  background: #15606e;
  border: 1px solid #2bf9fc;
  margin-top: 17vh !important;
}
.close-icon {
  width: 32px;
  height: 32px;
  position: absolute;
  top: 31px;
  right: 40px;
  cursor: pointer;
}
/deep/.el-dialog--center .el-dialog__body {
  padding: 0px 18px 20px;
}
p {
  margin-block-start: 0;
  margin-block-end: 0;
}
.text_center {
  text-align: center;
}
.flex_news {
  width: 100%;
  text-align: left;
  font-size: 16px;
  padding-left: 8px;
  margin-bottom: 2.3px;
  white-space: normal;
}
.swiper-container1 {
  width: 100%;
  min-height: unset;
  padding: 0 5px;
  font-size: 10px;
  margin-top: 5px;
  overflow: hidden;
}
.swiper-slide {
  text-align: center;
  font-size: 13px;
  /* Center slide text vertically */
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
  background-color: unset;
}
.activeColor {
  color: #3ef89c;
  text-shadow: 0 0 10px #3ef89c;
}
/deep/.el-dialog__header {
  padding: 24px 20px 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/rightAside/right.vue